import { useLocation } from 'react-router-dom';
import { useApp } from 'context/AppContext';
import { Container, Link } from './Styles';
import { currentGameConfig } from '../../utils/handleCurrentContentConfig';

const Fotter = () => {
  const { pathname } = useLocation();
  const { state } = useApp();
  const { user } = state;
  const { privacyPolicy, termsConditions, contactSupport } = currentGameConfig.info;
  return (
    <Container $isLoginPage={pathname === '/login'}>
      <Link href={privacyPolicy}>Privacy Policy</Link>
      <Link href={termsConditions}>Terms and Conditions</Link>
      <Link href={contactSupport + '?tSe=6' + (user ? `&uid=${user.uId}` : '')}>Contact Support</Link>
    </Container>
  );
};
export default Fotter;
